<template>
  <div class="ph-16 pb-24">
    <PrakerjaDetailExpandableSection title="" :content="content" :height="400" class="qa-test-merchant-about" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import PrakerjaDetailExpandableSection from '../PrakerjaDetailPage/PrakerjaDetailExpandableSection.vue';
import {orderBy} from 'lodash';
import {generateURLString} from 'shared_js/coupon-deals';

export default {
  name: 'PrakerjaMerchantAbout',
  components: {
    PrakerjaDetailExpandableSection,
  },
  computed: {
    ...mapGetters('merchants', ['getHighlightedMerchant', 'getMerchants']),
    ...mapGetters({
      merchantDetail: 'merchants/getMerchantDetail',
    }),
    currentYear() {
      const date = new Date();
      return date.getFullYear();
    },
    merchantName() {
      return this.merchantDetail.name;
    },
    sortedMerchants() {
      const mappedHG = this.getHighlightedMerchant.map((h) => h.id);
      const nonHighlightedMerchant = this.getMerchants.filter((e) => !mappedHG.includes(e.id));
      const sortedNonHighlightedMerchant = orderBy(nonHighlightedMerchant, [(user) => user.name.toLowerCase()]);
      return [...this.getHighlightedMerchant, ...sortedNonHighlightedMerchant]?.filter((e) => e.id !== this.merchantDetail.id);
    },
    merchantListAnchor() {
      const basePath = `https://www.bukalapak.com${process.env.BASE_PATH}/lembaga`;
      const merchantsHTML = this.sortedMerchants.map((merchant) => {
        return `<a style="color: #d71149" href="${basePath}/${generateURLString(
          `${merchant.name} ${merchant.id}`
        )}?source=merchant-about">${merchant.name}</a>`;
      });
      return merchantsHTML.join(', ');
    },
    content() {
      return `
        <h2 class="mv-16 bl-text bl-text--body-16 bl-text--bold">
          Daftar Kartu Prakerja ${this.currentYear} di ${this.merchantName}
        </h2>
        <p class="mb-16 bl-text bl-text--caption-12">
          Dengan menjadi peserta kelas Prakerja di ${this.merchantName}, akan tersedia akses ke sumber daya belajar yang lengkap, termasuk materi pembelajaran, tugas, dan proyek nyata yang akan meningkatkan kemampuan.
        </p>
        <p class="mb-16 bl-text bl-text--caption-12">
          Selain itu, kelas ${this.merchantName}, menggunakan pendekatan belajar berbasis proyek, mengaplikasikan pengetahuan yang diperoleh secara langsung dalam situasi kehidupan nyata akan lebih mudah.
        </p>
        <p class="mb-16 bl-text bl-text--caption-12">
          Jadi, ambil langkah maju dalam karier dan mempersiapkan diri untuk menghadapi tantangan di dunia kerja, bergabunglah dengan kelas Prakerja di ${this.merchantName} sekarang!
        </p>
        <h2 class="mb-16 bl-text bl-text--body-16 bl-text--bold">
          Kelas Prakerja di Bukalapak
        </h2>
        <p class="mb-16 bl-text bl-text--caption-12">
          Dapatkan berbagai voucher Kartu Prakerja ${this.merchantName} di Bukalapak. Selain ${this.merchantName}, juga terdapat banyak kelas lainnya seperti
          ${this.merchantListAnchor}
        </p>
      `;
    },
  },
};
</script>

<style>
.prakerja-merchant-about__text {
  margin-bottom: 16px;
}
</style>
